export default [
    {
        path: '/',
        name: 'home',
        component: () => import('../../views/Student/index'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            isAccessibleFor: ['student', 'teacher'],
            needsAuth: true,
        },
    },
    {
        path: '/schedule',
        name: 'schedule',
        component: () => import('../../views/Student/Schedule/Calendar'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/lesson-room/:webinarId',
        name: 'lessonRoom',
        component: () => import('../../views/Student/LessonRoom'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student', 'teacher'],
        },
    },
    {
        path: '/letter-1',
        name: 'letter-1',
        component: () => import('../../views/Student/Games/letter-1'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/letter/:id',
        name: 'letter.id',
        component: () => import('../../views/Student/Games/letter'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/letter-2',
        name: 'letter-2',
        component: () => import('../../views/Student/Games/letter-2'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/words',
        name: 'words',
        component: () => import('../../views/Student/Games/words'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/word/:id',
        name: 'word',
        component: () => import('../../views/Student/Games/word'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/subjects',
        name: 'subjects',
        component: () => import('../../views/Student/Subject/index'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/tests',
        name: 'tests',
        component: () => import('../../views/Student/Games/test'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/subject/:id',
        name: 'subject.view',
        component: () => import('../../views/Student/Subject/_id'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/support',
        name: 'support',
        component: () => import('../../views/Student/Support'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/personal',
        name: 'personal',
        component: () => import('../../views/Student/Personal/Index'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/password',
        name: 'password',
        component: () => import('../../views/Student/Personal/Password'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/knowledge-base',
        name: 'know.base',
        component: () => import('../../views/Student/Knowledge'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['student'],
        },
    },
    {
        path: '/schedule/webinar',
        name: 'schedule.webinar',
        component: () => import('../../views/Teacher/Schedule'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['teacher'],
        },
    },
    {
        path: '/webinars',
        name: 'webinars',
        component: () => import('../../views/Teacher/Webinars'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['teacher'],
        },
    },
    {
        path: '/homework/checking',
        name: 'homework.check',
        component: () => import('../../views/Teacher/HomeWorks'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['teacher'],
        },
    },
    {
        path: '/admin/trial',
        name: 'admin.trial',
        component: () => import('../../views/Admin/Trial'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/balances',
        name: 'admin.balances',
        component: () => import('../../views/Admin/Balance'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/webinars',
        name: 'admin.webinars',
        component: () => import('../../views/Admin/Webinars'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/transactions',
        name: 'admin.transactions',
        component: () => import('../../views/Admin/Transactions'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/teacher-schedule',
        name: 'admin.teacher-schedule',
        component: () => import('../../views/Admin/Teacher'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/student',
        name: 'admin.student',
        component: () => import('../../views/Admin/Student'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/payments',
        name: 'admin.payments',
        component: () => import('../../views/Admin/Payments'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/payments/:id',
        name: 'admin.payments.inner',
        component: () => import('../../views/Admin/Payments'),
        meta: {
            navActiveLink: 'admin.payments',
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/teacher-groups',
        name: 'admin.teacher.groups',
        component: () => import('../../views/Admin/TeacherGroups'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/transfer',
        name: 'admin.teacher.transfer',
        component: () => import('../../views/Admin/Transfer'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/groups',
        name: 'admin.groups',
        component: () => import('../../views/Admin/Group'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/subjects',
        name: 'admin.subjects',
        component: () => import('../../views/Admin/Subjects'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/programs',
        name: 'admin.programs',
        component: () => import('../../views/Admin/Programs'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/lessons',
        name: 'admin.lessons',
        component: () => import('../../views/Admin/Lessons'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/tests',
        name: 'admin.tests',
        component: () => import('../../views/Admin/Tests'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/tests/:id',
        name: 'admin.tests.detail',
        component: () => import('../../views/Admin/Tests/TestPackDetail'),
        meta: {
            navActiveLink: 'admin.tests',
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/admin/parental-control',
        name: 'admin.parental-control',
        component: () => import('../../views/Admin/ParentalControl/index'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['admin'],
        },
    },
    {
        path: '/parental-control/dashboard',
        name: 'parental-control.dashboard',
        component: () => import('../../views/ParentalControl/Dashboard'),
        meta: {
            layout: 'vertical',
            resource: 'Auth',
            action: 'read',
            needsAuth: true,
            isAccessibleFor: ['parent'],
        },
    },


]
